"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewCalculatorResult extends new_item_1.default {
    constructor(newCalculatorResult) {
        super();
        this.inboundId = newCalculatorResult.inboundId;
        this.totalSavingData = newCalculatorResult.totalSavingData;
        this.applianceSavingData = newCalculatorResult.applianceSavingData;
        this.hours = newCalculatorResult.hours;
        this.appliances = newCalculatorResult.appliances;
        this.receivedSavingEmail = newCalculatorResult.receivedSavingEmail;
    }
}
exports.default = NewCalculatorResult;
//# sourceMappingURL=new-calculatorResult.js.map